import React, { useState } from 'react';
import { Box, Card, CardContent, TextField, Button, Typography, Alert, Stepper, Step, StepLabel } from '@mui/material';
import RadarIcon from '@mui/icons-material/Radar';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate, Link } from 'react-router-dom';

const steps = ['Dados da Organização', 'Dados do Administrador'];

const RegisterPage = () => {
    const { login } = useAuth();
    const navigate = useNavigate();
    const [activeStep, setActiveStep] = useState(0);
    const [form, setForm] = useState({ tenantName: '', tenantCnpj: '', name: '', email: '', password: '' });
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const api = require('../services/api').default;

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (activeStep === 0) { setActiveStep(1); return; }
        setError(''); setLoading(true);
        try {
            await api.post('/auth/register', form);
            await login(form.email, form.password);
            navigate('/dashboard');
        } catch (err) {
            setError(err.response?.data?.message || 'Erro ao realizar cadastro');
        } finally { setLoading(false); }
    };

    const set = (field) => (e) => setForm(f => ({ ...f, [field]: e.target.value }));

    return (
        <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#f4f6f9', p: 2 }}>
            <Card sx={{ width: '100%', maxWidth: 480, p: 2 }}>
                <CardContent>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3 }}>
                        <RadarIcon color="primary" sx={{ fontSize: 32 }} />
                        <Typography variant="h5" color="primary" fontWeight={700}>Compras Radar</Typography>
                    </Box>
                    <Typography variant="h6" fontWeight={700} mb={0.5}>Cadastrar Organização</Typography>
                    <Typography variant="body2" color="text.secondary" mb={3}>Configure a sua conta para começar</Typography>

                    <Stepper activeStep={activeStep} sx={{ mb: 3 }}>
                        {steps.map(label => <Step key={label}><StepLabel>{label}</StepLabel></Step>)}
                    </Stepper>

                    {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

                    <Box component="form" onSubmit={handleSubmit} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                        {activeStep === 0 ? (
                            <>
                                <TextField label="Nome da Organização" value={form.tenantName} onChange={set('tenantName')} fullWidth required />
                                <TextField label="CNPJ (opcional)" value={form.tenantCnpj} onChange={set('tenantCnpj')} fullWidth placeholder="00.000.000/0001-00" />
                            </>
                        ) : (
                            <>
                                <TextField label="Seu nome" value={form.name} onChange={set('name')} fullWidth required />
                                <TextField label="E-mail" type="email" value={form.email} onChange={set('email')} fullWidth required />
                                <TextField label="Senha" type="password" value={form.password} onChange={set('password')} fullWidth required inputProps={{ minLength: 6 }} helperText="Mínimo 6 caracteres" />
                            </>
                        )}
                        <Box sx={{ display: 'flex', gap: 2 }}>
                            {activeStep > 0 && <Button variant="outlined" fullWidth onClick={() => setActiveStep(0)}>Voltar</Button>}
                            <Button type="submit" variant="contained" fullWidth size="large" disabled={loading}>
                                {activeStep === 0 ? 'Continuar' : loading ? 'Cadastrando...' : 'Criar conta'}
                            </Button>
                        </Box>
                    </Box>

                    <Typography variant="body2" align="center" mt={2}>
                        Já tem conta? <Typography component={Link} to="/login" variant="body2" color="primary" sx={{ textDecoration: 'none', fontWeight: 600 }}>Entrar</Typography>
                    </Typography>
                </CardContent>
            </Card>
        </Box>
    );
};

export default RegisterPage;
